import React from 'react';

function Readings() {
  return (
    <section>
      <h2>What I've been reading recently</h2>
      <p>Things that have inspired me.</p>
    </section>
  );
}

export default Readings;